/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useEffect,useState,useCallback,useContext} from 'react'
import HeaderContext from '../../Components/Context/HeaderContext'
import WishlistContext from '../../Components/Context/WishlistContext'
import { distributorService } from '../../service/distributor.service'
import WishLayout from './wishLayout'
import WishlistCard from './WishlistCard'
import './style.css'
import ReactModal from 'react-modal'
import MoveAllToCartModal from './MoveAllToCartModal'

function Wish({children,props}) {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup,
        GetCartItems
    } = useContext(HeaderContext);    const [productList, setproductList] = useState([])
    const [selectedWishlist, setselectedWishlist] = useState({})
    const [loading, setloading] = useState(true)
    const [list, setlist] = useState([])
    const [modalType, setmodalType] = useState('');
    const [selectedProduct, setselectedProduct] = useState({});
    const [addtocartPopup, setaddtocartPopup] = useState('');
    const [CartpopupLoader, setCartpopupLoader] = useState(false)
    const handlefetch = useCallback(
        (prev,id) => {
            distributorService.ListwhishList().then((item)=>{
                if(!item.error && item.data.success_status){
                    if(prev===undefined){
                        setselectedWishlist(item.data.data[0]);
                        setlist(item.data.data)
                    }else{
                        const idx = item.data.data.map((item)=>item.collection_id).indexOf(id)
                        setselectedWishlist({
                            collection_id:item.data.data[idx].collection_id,
                            collection_name:item.data.data[idx].collection_name
                        })
                        setlist(item.data.data);
                    }
                }
            })
        },
        [],
    )
    useEffect(() => {
        handlefetch()
    }, [handlefetch])
    const getWishlistProductList = useCallback(
        async(id) => {
            const products = await distributorService.ListwhishListProducts(id);
            if(!products.error && products.data.success_status){
                setproductList(products.data.data);
                setTimeout(()=>{
                    setloading(false)
                },1000)
                
            }
        },
        [selectedWishlist],
    )
    useEffect(() => {
        getWishlistProductList(selectedWishlist.collection_id)
    }, [getWishlistProductList])
    const removeAll = async(id) => {
        const products = await distributorService.removeAllProducts('',selectedWishlist.collection_id);
        if(!products.error && products.data.success_status){
            handleSuccess(selectedWishlist.collection_name,"All products removed from wishlist",'');
            setproductList([])
        }
    }
    
    const removeParticular = async() => {
        const copy=[...productList]
        const products = await distributorService.removeParticular(selectedWishlist.collection_id,selectedProduct.item_id);
        if(!products.error && products.data.success_status){
            const message="Removed from wishlist";
            const idx = copy.map((item)=>item.item_id).indexOf(selectedProduct.item_id);
            copy.splice(idx,1)
            setproductList(copy)
            handleSuccess(selectedWishlist.collection_name,message,'diff')
        }else{
            handleError(products.message.response.data.message)
        }
    }
    const AddToCart = async() => {
        const payload={
            "collection_id":selectedWishlist.collection_id,
        }
        let products;
        if(addtocartPopup==='all'){
            products =  await distributorService.moveAlltoCartFromWishlist(payload);

        }else{
            products =  await distributorService.AddtoCartFromWishlist(addtocartPopup,selectedWishlist.collection_id);

        }
        if(!products.error && products.data.success_status){
            handleSuccess(selectedWishlist.collection_name,products.data.message,'diff');
            setCartpopupLoader(false);
            setaddtocartPopup('')
            setTimeout(() => {
                handlefetch(selectedWishlist.collection_name,selectedWishlist.collection_id)  

            }, 2000);
        }else{
            handleError(products.message.response.data.message)
        }
    }
    const handleError = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setmodalType('')
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }
    const handleSuccess = (name,message,diff)=>{
        if(diff===undefined){
            SetSuccessMessage(`Wishlist ${message}`);
            handlefetch()

        }else{
            SetSuccessMessage(`${message}`);

        }
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setmodalType('')
            if(diff===undefined){
                handlefetch(name,selectedWishlist.collection_id)  

            }
        }, 1000);
    }
    const handleRemoveModal = (prod,selecId,type)=>{
        setmodalType(type);
        setselectedProduct(prod)
    }
    return (
        <WishlistContext.Provider
            value={{
                selectedWishlist,
                setselectedWishlist,
                productList,
                loading,
                setloading,
                removeParticular,
                removeAll,
                handleRemoveModal,
                list,
                setlist,
                handleError,
                handleSuccess,
                modalType,
                selectedProduct,
                setaddtocartPopup,
                addtocartPopup,
                setmodalType}}
        >
            <WishLayout {...props} selectedWishlist={selectedWishlist}
                setselectedWishlist={setselectedWishlist}>
                <WishlistCard Products={productList} loading={loading} {...props} />
            </WishLayout>
            <ReactModal style={{overFlow:'auto'}} isOpen={addtocartPopup !==''}>
                <MoveAllToCartModal
                    keyval={addtocartPopup} 
                    setaddtocartPopup={setaddtocartPopup}
                    loading={CartpopupLoader}
                    AddToCart={AddToCart}
                    setloading={setCartpopupLoader}/>
            </ReactModal>
        </WishlistContext.Provider>
    )
}

export default Wish